import { Injectable, Injector } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { EstimativaStaffPlan, EstimativaStaffPlanResult, EstimativaStaffPlanUpdate } from '../models/estimativa-staff-plan.model';
import { Page } from '../models/page.model';

@Injectable({
  providedIn: 'root'
})

export class EstimativaStaffPlanService extends BaseService<EstimativaStaffPlan> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/EstimativaStaffPlan`, injector);
  }

  getByEstimativaId(estimativaId: number): Observable<Page<EstimativaStaffPlanResult>> {
    return this.http.get<Page<EstimativaStaffPlanResult>>(`${environment.API_PRICE}/EstimativaStaffPlan/GetByEstimativaId/${estimativaId}`);
  }

  update(entity: EstimativaStaffPlan): Observable<EstimativaStaffPlan> {
    return this.http.put<EstimativaStaffPlan>(`${environment.API_PRICE}/EstimativaStaffPlan/Update`, entity);
  }

  montarRecomendacao(idEstimativa: number) {
    return this.http.get(`${environment.API_PRICE}/EstimativaStaffPlan/MontarRecomendacao/${idEstimativa}`);
  }

  estimativaAlterouDados(estimativaId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiPath}/EstimativaAlterouDados/${estimativaId}`);
  }

  updateProfissionalBasicData(update: EstimativaStaffPlanUpdate): Observable<EstimativaStaffPlan> {
    return this.http.put<EstimativaStaffPlan>(`${environment.API_PRICE}/EstimativaStaffPlan/Update`, update);
  }

  alterarPerfilProfissional(dados: { estimativaId: number, estimativaStaffPlanId: number, profissionalId: number, cargoId: number }): Observable<any> {
    return this.http.put<any>(`${environment.API_PRICE}/EstimativaStaffPlan/AlterarPerfilProfissional`, dados);
  }

  /** Atualiza a descrição da fase usando o id retornado pela API (idDescricaoFase). PUT com body JSON. */
  updateDescricaoFase(idDescricaoFase: number, descricaoFase: string): Observable<any> {
    const url = `${environment.API_PRICE}/EstimativaStaffPlan/UpdateDescricaoFase/${idDescricaoFase}`;
    const body = { descricaoFase };
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<any>(url, body, { headers });
  }
}